import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/voltage-drop-calculator',
  component: () => import('../../routes/VoltageDropCalculator.svelte'),
  card: {
    id: 'voltage-drop-calculator',
    title: 'Voltage Drop Calculator',
    description:
      'Calculate voltage drop, end-of-circuit voltage, and power loss for any wire run. Supports copper / aluminum, 14 AWG through 4/0, DC / single-phase / three-phase. Uses NEC Chapter 9 Table 8 resistance values and gives a 5-bucket severity rating (excellent / good / acceptable / marginal / excessive).',
    icon: 'electrical_services',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/voltage-drop-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title:
      'Voltage Drop Calculator – NEC-Compliant Vd, End Voltage & Power Loss',
    description:
      'Free voltage drop calculator: Vd = 2·L·I·R/1000 (1φ / DC) or Vd = √3·L·I·R·cosφ/1000 (3φ). Supports copper and aluminum, 14 AWG to 4/0, DC / 1-phase / 3-phase, with NEC 3% and 5% guideline checks. Includes end-of-circuit voltage, power loss, and 8 preset circuits (kitchen, EV charger, subpanel, solar, pool pump, tiny house).',
  },
};

export default meta;
